export const CHILDREN_BUSINESS_UNIT = new Set(['fund', 'company']);
export const TOP_LEVEL_BUSINESS_UNIT = new Set(['standalone', 'firm']);
export const FIRM_KIND = 'firm';
export const STANDALONE_KIND = 'standalone';
export const COMPANY_KIND = 'company';
export const FUND_KIND = 'fund';

export const FILTER_BLOCKS_SIZE = '3em';
export const DATE_INPUT_WIDTH = '8em';

export const BUSINESS_UNIT_QUERY_PARAMS = ['company', 'firm', 'fund'];
export const MAX_CHANGED_PAYLOAD_LENGTH = 100;
